import { render } from "./AddDomaineActiviteModal.vue?vue&type=template&id=2861953e&ts=true"
import script from "./AddDomaineActiviteModal.vue?vue&type=script&lang=ts"
export * from "./AddDomaineActiviteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__